import { User } from "../services/api";
import { JoinRequest } from "../components/UserManagement/JoinRequestList";
import { normalizePhoneNumber, phoneMatchesSearch } from "./phoneUtils";

/** Pending join requests that still need action (excludes users already on the platform). */
export function filterActionableJoinRequests(
  joinRequests: JoinRequest[],
  users: User[],
  searchQuery = ""
): JoinRequest[] {
  const activeEmails = new Set(
    users
      .map((user) => user.email?.trim().toLowerCase())
      .filter((email): email is string => Boolean(email))
  );
  const activePhones = new Set(
    users
      .map((user) =>
        user.phoneNumber ? normalizePhoneNumber(user.phoneNumber) : ""
      )
      .filter(Boolean)
  );

  let filtered = joinRequests.filter((request) => {
    const requestEmail = request.email?.trim().toLowerCase();
    if (requestEmail && activeEmails.has(requestEmail)) {
      return false;
    }

    const requestPhone = request.cellNumber
      ? normalizePhoneNumber(request.cellNumber)
      : "";
    if (requestPhone && activePhones.has(requestPhone)) {
      return false;
    }

    return true;
  });

  if (searchQuery.trim()) {
    const q = searchQuery.toLowerCase();
    filtered = filtered.filter(
      (request) =>
        request.learnerName.toLowerCase().includes(q) ||
        request.learnerSurname.toLowerCase().includes(q) ||
        request.parentName.toLowerCase().includes(q) ||
        request.email.toLowerCase().includes(q) ||
        phoneMatchesSearch(request.cellNumber, searchQuery) ||
        (request.gradeClass && request.gradeClass.toLowerCase().includes(q))
    );
  }

  return filtered;
}
